<template lang="pug">
div
  template(v-if="showNewConsultation")
    consultation-new
  template(v-else)
    consultation-old(@showUpgradeDialog="showDialog = true; showSnackbar = false")

  .modal
    v-snackbar.ml-8.mb-4(v-model="showSnackbar" :timeout="-1" bottom left color="blue100")
      div.d-flex.align-center
        v-icon(size="32" color="neutral700") $yzi-layout-alt-duotone-04
        div.ml-3
          div.text-xs.neutral700--text.font-semibold New & Improved Consultation Page
          div.text-xs.neutral700--text Streamlined for speed and clarity.
        v-spacer
        y-button(label="Learn more" color="neutral700" size="xs" button-class="px-3" height="24" @click="showDialog = true; showSnackbar = false")
    y-dialog(v-model="showDialog" persistent content-class="round-2xl")
      v-card
        v-card-title.pa-4
          v-row(no-gutters align="center")
            v-col(cols="10" offset="1")
              div.text-md.font-semibold.text-center.neutral700--text All new Consultation page
            v-col(cols="1" align="right")
              v-btn(icon @click="showDialog = false" small color="primary")
                v-icon mdi-close
        v-card-text.px-6
          v-row(align="center")
            v-col(cols="6")
              div(style="border: 1px solid var(--v-neutral300);")
                v-img(src="@/assets/images/consultation1.png" eager)
                div.px-4.py-5
                  div.text-sm.font-semibold.neutral700--text Easier to scan layout
                  div.text-sm.font-medium.neutral700--text.mt-1 Navigate flexibly with a simplified two-panel layout for faster access to key patient and treatment details.
            v-col(cols="6")
              div(style="border: 1px solid var(--v-neutral300);")
                v-row(no-gutters)
                  v-col(cols="7")
                    v-img(src="@/assets/images/consultation2.png" eager)
                  v-col(cols="5")
                    div.px-4.py-5
                      div.text-sm.font-semibold.neutral700--text Underlying conditions
                      div.text-sm.font-medium.neutral700--text.mt-1 Add underlying conditions to have a better context from the start. Supporting more accurate & informed care.
              div.mt-6(style="border: 1px solid var(--v-neutral300);")
                v-row(no-gutters)
                  v-col(cols="7")
                    v-img(src="@/assets/images/consultation3.png" eager)
                  v-col(cols="5")
                    div.px-4.py-5
                      div.text-sm.font-semibold.neutral700--text New treatment table
                      div.text-sm.font-medium.neutral700--text.mt-1 Quickly search, select, and add treatments, whether in bulk or from past visits. All in one streamlined table, making consultations faster and more efficient.

        v-divider
        v-card-actions.pb-4.pt-3.px-6
          v-spacer
          y-button.mr-5(label="Watch video to learn more" color="neutral400" text-color="neutral700" outlined size="md" @click="watchVideo")
          y-button(label="Switch to new version" color="neutral700" size="md" dark :loading="isLoading" @click="switchConsultation")

</template>

<script>
import { mapState } from 'vuex'
import ConsultationOld from '@/components/clinic/consultation/ConsultationOld.vue'
import ConsultationNew from '@/components/clinic/consultation/ConsultationNew.vue'

export default {
  name: 'ConsultationDetails',
  components: { ConsultationOld, ConsultationNew },
  data() {
    return {
      isLoading: false,
      showSnackbar: false,
      showDialog: false
    };
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapState('clinic', ['cmsOsV2Enabled']),
    showNewConsultation () {
      return this.cmsOsV2Enabled || this.member?.extra_data?.new_consultation || false
    }
  },
  mounted () {
    this.$store.dispatch('clinic/fetchCmsOsV2', this.$axios)
    this.checkConsultationVersion()
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  methods: {
    handleBeforeUnload(event) {
      event.preventDefault()
      event.returnValue = ''
      return ''
    },
    checkConsultationVersion () {
      this.$nextTick(() => {
        if (!this.showNewConsultation && !this.cmsOsV2Enabled) {
          this.showSnackbar = true
        }
      })
    },
    switchConsultation() {
      this.isLoading = true
      let params = {
        extra_data: {
          ...this.member.extra_data,
          new_consultation: true
        }
      }
      this.$axios.patch(`/members/${this.member.id}/`, params)
        .then(resp => {
          this.$store.commit('user/setMember', resp.data)
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    watchVideo() {
      window.open('https://www.loom.com/share/e1be857ae9464bd8ad8a21cec1981664?sid=e7a12522-2222-47bd-a0a4-f1f9e0bb5836', '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-sheet.v-snack__wrapper {
    border-radius: 10px;
    width: 400px !important;
  }
}
</style>